/*
------------------------------------------------------------------
SWIFT — Benefits (scrolling) section

Highlights whichever benefit is at the reading line and cross-fades
the sticky frame to its image. Layout does the pinning; this only
decides which pane is active.
------------------------------------------------------------------
*/
(function () {
  'use strict';

  var STACKED_BREAKPOINT = 861; // below this the section stacks and the frame is hidden

  function BenefitsScroll(root) {
    this.root = root;
    this.panes = Array.prototype.slice.call(
      root.querySelectorAll('[data-benefit-pane]')
    );
    this.images = Array.prototype.slice.call(
      root.querySelectorAll('[data-benefit-image]')
    );
    this.pips = Array.prototype.slice.call(
      root.querySelectorAll('[data-benefit-pip]')
    );
    this.current = -1;
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.update);
    this.update();
  }

  BenefitsScroll.prototype.setIndex = function (i) {
    if (i === this.current) return;
    this.current = i;
    this.panes.forEach(function (el, n) {
      el.classList.toggle('is-active', n === i);
    });
    this.images.forEach(function (el, n) {
      el.classList.toggle('is-active', n === i);
    });
    this.pips.forEach(function (el, n) {
      el.classList.toggle('is-active', n === i);
    });
  };

  BenefitsScroll.prototype.onScroll = function () {
    if (this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(this.update);
  };

  BenefitsScroll.prototype.update = function () {
    this.ticking = false;
    if (!this.panes.length) return;

    if (window.innerWidth < STACKED_BREAKPOINT) {
      this.setIndex(0);
      return;
    }

    /* The last pane whose top has crossed the reading line.
       Capped against the first pane's own height as well as the viewport, so
       benefit 01 always gets its turn no matter how wide the column is or how
       many lines the copy wraps to — a fixed pixel anchor breaks the moment
       the theme's column differs from the design comp. */
    var firstPaneHeight = this.panes.length > 1
      ? this.panes[1].offsetTop - this.panes[0].offsetTop
      : Infinity;

    var anchor = Math.min(
      window.innerHeight * 0.28,
      300,
      firstPaneHeight - 24
    );
    var active = 0;

    this.panes.forEach(function (pane, n) {
      if (pane.getBoundingClientRect().top <= anchor) active = n;
    });

    this.setIndex(active);
  };

  BenefitsScroll.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.update);
  };

  /* ---- lifecycle ------------------------------------------------ */

  var instances = {};

  function mount(scope) {
    var roots = (scope || document).querySelectorAll('[data-ss-benefits]');
    Array.prototype.forEach.call(roots, function (root) {
      var id = root.getAttribute('data-ss-benefits');
      if (instances[id]) instances[id].destroy();
      instances[id] = new BenefitsScroll(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(); });
  } else {
    mount();
  }

  /* Theme editor: sections are re-rendered on edit, so re-bind. */
  document.addEventListener('shopify:section:load', function (e) {
    mount(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-ss-benefits]');
    if (!root) return;
    var id = root.getAttribute('data-ss-benefits');
    if (instances[id]) {
      instances[id].destroy();
      delete instances[id];
    }
  });

  /* Selecting a benefit block in the editor should preview that benefit. */
  document.addEventListener('shopify:block:select', function (e) {
    var pane = e.target.closest
      ? e.target.closest('[data-benefit-pane]')
      : null;
    if (!pane) return;
    var root = pane.closest('[data-ss-benefits]');
    if (!root) return;
    var inst = instances[root.getAttribute('data-ss-benefits')];
    if (inst) inst.setIndex(parseInt(pane.getAttribute('data-index'), 10) || 0);
  });
})();
